<template>
    <div :key="id" class="table-input">
        <b-form-input :readonly="readonly"
            type="number"
            v-model="raw_value" v-on:change="change"
            @input="validate" :formatter="formatter"
            :state="state" :aria-describedby="`field_${id}`"
        />
        <b-form-invalid-feedback :id="`field_${id}`" tooltip>
            {{ validation.msg }}<template v-if="!is_not_required">, обязательное значение</template>
        </b-form-invalid-feedback>
    </div>
</template>

<script>
import { uuid } from 'vue-uuid';
import api from '../../api';


export default {
    props :
    {
        value : { type : [String, Number], default : () => undefined },
        item : Object,
        readonly : { type: Boolean, default : false },
        validation : Object,
        return_str : { type : Boolean, default : false },
        return_bad : { type : Boolean, default : false },
        is_not_required : { type : Boolean, default : false }
    },

    data()
    {
        return {
            id : uuid.v1(),
            state : null,
            raw_value : null
        }
    },

    watch :
    {
        item :
        {
            handler()
            {
                this.id = uuid.v1()
                this.state = this.validation.check(this.value) || this.readonly || (this.is_not_required && (this.value == null || this.value === "")) ? null : false

                if (this.value !== null && this.value !== undefined)
                {
                    this.raw_value = this.value.toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 30 })
                }
                else
                {
                    this.raw_value = this.value
                }
            },
            immediate: true
        },

        readonly(newValue)
        {
            this.state = this.validation.check(this.value) || newValue ? null : false
        },

        value :
        {
            handler()
            {
                if (this.value !== null && this.value !== undefined)
                {
                    this.raw_value = this.value.toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 30 })
                }
                else
                {
                    this.raw_value = this.value
                }
            },
            immediate: true
        }
    },

    methods :
    {
        check_roles(roles)
        {
            return api.check_roles(this, roles)
        },

        formatter(value)
        {
            if (
                value === ""
                || (this.validation.gt_min !== undefined && Number(value) === this.validation.gt_min)
                || (this.validation.lt_max !== undefined && Number(value) === this.validation.lt_max)
                || this.validation.check(value)
            )
            {
                return value
            }
            else
            {
                return this.raw_value
            }
        },

        validate(value)
        {
            this.validation.check(value) || (this.is_not_required && (value == null || value === "")) ? this.state = null : this.state = false
        },

        change(value)
        {
            if (!this.readonly && this.validation.check(value) || (this.is_not_required && (value == null || value === "")) || this.return_bad)
            {
                const prepared_value = this.return_str
                    ? value
                    : (value == null || value === "")
                        ? null
                        : Number(value)

                this.$emit('change', prepared_value)
            }
            else
            {
                this.raw_value = this.value.toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 30 })
                this.validate(this.raw_value)
            }
    
        }
    }

}
</script>

<style>
.table-input
{
    position: relative;
}

.table-input .invalid-tooltip
{
    display: none;
    top: 1.625rem;
    left: unset;
    right: .5rem;
    background-color: var(--bft-neutral-900-tooltip);
    max-width: max-content;
}

.table-input .form-control.is-invalid:hover + .invalid-tooltip
{
    display: block;
}
</style>
